import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createCustomerType(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(EntityTypeEnum.CustomerType, parentId, masterBlockId),
    type: EntityTypeEnum.CustomerType,
  }
}
